// Duplicated from service-desk — code duplication is accepted between dashboard-ui and service-desk
// (service-desk is a sealed UMD bundle; dashboard-ui is the host shell)
import { gql } from '@apollo/client';

export const SearchQARuleEntries = gql`
  mutation SearchQarule($request: SearchQaruleRequest!) {
    SearchQarule(request: $request) {
      data
      total
    }
  }
`;

export const QueryGroupUserRoles = gql`
  mutation QueryGroupUserRoles($groupUserRolesQuery: groupUserRolesQuery!) {
    QueryGroupUserRoles(groupUserRolesQuery: $groupUserRolesQuery)
  }
`;

export const QueryWorkers = gql`
  mutation QueryWorker($workerQuery: workerQuery!) {
    QueryWorker(workerQuery: $workerQuery)
  }
`;

export const QueryWorkItemCounts = gql`
  mutation QueryWorkItems($workItemQuery: workItemQuery!) {
    QueryWorkItems(workItemQuery: $workItemQuery) {
      data
      total
    }
  }
`;

const formatSql = (strings: TemplateStringsArray, ...values: any[]) => {
  const sql = strings.reduce((result, str, i) => result + str + (values[i] || ''), '');
  return sql.replace(/\s+/g, ' ').trim();
};

export const QueryWorkItemsForProject = (collectionIds: string[]) =>
  formatSql`
    SELECT
        COUNT(CASE WHEN qa_status = 'CQA_COMPLETE' THEN 1 END) AS completed_workitems,
        COUNT(CASE WHEN qa_status = 'IN_CQA' THEN 1 END) AS in_progress_workitems,
        COUNT(CASE WHEN qa_status = 'CQA_APPROVED' THEN 1 END) AS approved_workitems,
        COUNT(CASE WHEN qa_status = 'CQA_CLOSED' THEN 1 END) AS closed_workitems,
        qa_collection_id
    FROM workitem
    WHERE qa_status IN ('IN_CQA', 'CQA_COMPLETE', 'CQA_APPROVED', 'CQA_CLOSED')
        AND qa_collection_id IN (${collectionIds.map(id => `'${id}'`).join(',')})
        AND status = 'ACTIVE'
    GROUP BY qa_collection_id
    ORDER BY qa_collection_id;
  `;

export const QueryWorkItemsForProjectPerWorker = (collectionIds: string[], workerId: string) =>
  formatSql`
    SELECT
        COUNT(CASE WHEN qa_status = 'CQA_COMPLETE' THEN 1 END) AS completed_workitems,
        COUNT(CASE WHEN qa_status = 'IN_CQA' THEN 1 END) AS in_progress_workitems,
        qa_collection_id
    FROM workitem
    WHERE qa_status IN ('IN_CQA', 'CQA_COMPLETE')
        AND qa_collection_id IN (${collectionIds.map(id => `'${id}'`).join(',')})
        AND status = 'ACTIVE'
        AND assignee = '${workerId}'
    GROUP BY qa_collection_id
    ORDER BY qa_collection_id;
  `;
